import CharacterText from "./characterText";

export default CharacterText;